import { cva } from 'class-variance-authority';

export const select = cva(
  [
    `
      appearance-none
      outline-none
    
      bg-transparent
      text-primary
      
      shadow-none

      motion-safe:transition  

      flex
      items-center
      justify-between

      focus-visible:ring

      disabled:opacity-40
      disabled:pointer-events-none

      [&>span]:whitespace-nowrap
      [&>span]:text-ellipsis
      [&>span]:overflow-hidden

      [&[aria-expanded="true"]_[data-icon="chevron-down"]]:rotate-180
      [&_[data-icon="chevron-down"]]:motion-safe:transition
      [&_[data-icon="chevron-down"]]:duration-200
    `
  ],
  {
    variants: {
      variant: {
        default: `
          text-sm
          font-semibold

          rounded-sm

          hover:bg-primary/2

          focus-visible:border-accent
          focus-visible:bg-primary/2

          border
          border-primary/18

          pr-2.5
          pl-3.5
          h-10
          gap-2
        `,
        link: `
          rounded-xs
          gap-1
          hover:text-primary/96
          px-1
          py-0.5
        `
      },
      size: { md: '', sm: '' }
    },
    compoundVariants: [
      { variant: 'link', size: 'md', class: 'text-md' },
      { variant: 'link', size: 'sm', class: 'text-sm' }
    ]
  }
);

export const content = cva([
  'bg-highlight p-1 border border-primary/8 rounded-sm max-h-52 overflow-y-auto z-popover [&>*]:space-y-0.5'
]);

export const item = cva([
  'text-md px-3 whitespace-nowrap h-[34px] flex gap-1 motion-safe:transition items-center justify-between rounded-xs cursor-pointer [&[data-highlighted]]:bg-primary/4 [&_[data-icon]]:text-accent [&_[data-icon]]:-mr-[5px]'
]);

export const label = cva(['px-3 h-[34px] flex items-center text-primary/50']);
